import { render, staticRenderFns } from "./FightersSliderItem.vue?vue&type=template&id=f8b0abd6&lang=pug&"
import script from "./FightersSliderItem.vue?vue&type=script&lang=js&"
export * from "./FightersSliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports